// @module Tavanoteam.Prop65Warning.Prop65Warning
define('Tavanoteam.Prop65Warning.Prop65Warning.View'
	, [
		'tavanoteam_prop65warning_prop65warning.tpl'

		, 'Backbone'
	]
	, function (
		tavanoteam_prop65warning_prop65warning_tpl

		, Backbone
	) {
		'use strict';

		// @class Tavanoteam.Prop65Warning.Prop65Warning.View @extends Backbone.View
		return Backbone.View.extend({

			template: tavanoteam_prop65warning_prop65warning_tpl

			, initialize: function (options) {
				this.pdpComponent = options.container.getComponent('PDP');
				this.item = this.pdpComponent.getItemInfo().item;
			}

			, getProp65Message: function () {
				var message = this.item.custitemcustitem_prop_65_message;

				switch (message) {
					case 'Cancer':
						return 'This product contains a chemical known to the State of California to cause cancer.';
					case 'Reproductive Harm':
						return 'This product contains a chemical known to the State of California to cause reproductive harm.'
					case 'Cancer & Reproductive Harm':
						return 'This product contains a chemical known to the State of California to cause cancer and reproductive harm.';
					default:
						return message;
				}
			}

			, getContext: function getContext() {
				//@class Tavanoteam.Prop65Warning.Prop65Warning.View.Context

				var prop65Message = this.getProp65Message();

				return {
					prop65Message: prop65Message
				};
			}
		});
	});
